<template>
	<div v-if="shouldShow" class="valid-feedback" :class="{ 'd-block': forceShow }">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'BFormValidFeedback',
	props: {
		state: {
			type: Boolean,
			default: null
		},
		forceShow: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		shouldShow() {
			return this.forceShow || this.state === true
		}
	}
}
</script>
